module.exports = __webpack_public_path__ + "static/media/Inspiration.27e98363.svg";